import { ActionType } from '../../definitions';
import actionTypes from '../constants/actionTypes';

export const closeModal = (payload = {}): ActionType => ({
  type: actionTypes.modal.close,
  payload,
});
